import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CreateStickerComponent } from "./create-sticker.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
import { QuillModule } from "ngx-quill";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { JwBootstrapSwitchNg2Module } from "jw-bootstrap-switch-ng2";

@NgModule({
  declarations: [CreateStickerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSmartModalModule,
    QuillModule.forRoot(),
    NgSelectModule,
    NgxDatatableModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      backdropBorderRadius: "3px",
    }),
    JwBootstrapSwitchNg2Module,
  ],
})
export class CreateStickerModule {}
